module.exports = __webpack_public_path__ + "static/media/55_000063.6f003a4c.jpg";